import React, { Fragment, useState } from 'react';
import LabelIcon from '@material-ui/icons/Label';
import { useMediaQuery } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DashboardMenuItem, MenuItemLink, getResources, useTranslate } from 'react-admin';
import PropTypes from 'prop-types';
import { shallowEqual, useSelector } from 'react-redux';
import classnames from 'classnames';
import DefaultIcon from '@material-ui/icons/ViewList';
import ExpandMore from '@material-ui/icons/ExpandMore';
import List from '@material-ui/core/List';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Typography from '@material-ui/core/Typography';
import Collapse from '@material-ui/core/Collapse';
import Tooltip from '@material-ui/core/Tooltip';

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};













var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};







var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var useStyles = makeStyles(function (theme) {
    return {
        icon: { minWidth: theme.spacing(5) },
        sidebarIsOpen: {
            paddingLeft: 25,
            transition: 'padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms'
        },
        sidebarIsClosed: {
            paddingLeft: 0,
            transition: 'padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms'
        },
        menuItem: {},
        menuItemName: {
            color: theme.palette.text.secondary
        },
        openMenuItem: {}
    };
}, { name: 'RaTreeCustomMenuItem' });

var CustomMenuItem = function CustomMenuItem(_ref) {
    var handleToggle = _ref.handleToggle,
        sidebarIsOpen = _ref.sidebarIsOpen,
        isOpen = _ref.isOpen,
        name = _ref.name,
        icon = _ref.icon,
        children = _ref.children,
        dense = _ref.dense;

    var classes = useStyles();
    var translate = useTranslate();

    var header = React.createElement(
        MenuItem,
        {
            key: name,
            dense: dense,
            button: true,
            onClick: handleToggle,
            className: classnames(classes.menuItem, defineProperty({}, classes.openMenuItem, isOpen))
        },
        React.createElement(
            ListItemIcon,
            { className: classes.icon },
            isOpen ? React.createElement(ExpandMore, null) : icon
        ),
        React.createElement(
            Typography,
            {
                variant: 'inherit',
                className: classnames(classes.menuItemName, 'menuItemName')
            },
            translate(name)
        )
    );

    return React.createElement(
        Fragment,
        null,
        sidebarIsOpen || isOpen ? header : React.createElement(
            Tooltip,
            { title: translate(name), placement: 'right' },
            header
        ),
        React.createElement(
            Collapse,
            { 'in': isOpen, timeout: 'auto', unmountOnExit: true },
            React.createElement(
                List,
                {
                    dense: dense,
                    component: 'div',
                    disablePadding: true,
                    className: sidebarIsOpen ? classes.sidebarIsOpen : classes.sidebarIsClosed,
                    style: { display: "flex", flexDirection: "column", alignItems: 'left' }
                },
                children
            )
        )
    );
};

var useStyles$1 = makeStyles(function (theme) {
    var _main;

    return {
        main: (_main = {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            marginTop: '0.5em'
        }, defineProperty(_main, theme.breakpoints.only('xs'), {
            marginTop: 0
        }), defineProperty(_main, theme.breakpoints.up('md'), {
            marginTop: '1.5em'
        }), _main)
    };
}, { name: 'RaTreeMenu' });

var Menu = function Menu(props) {
    var className = props.className,
        dense = props.dense,
        hasDashboard = props.hasDashboard,
        onMenuClick = props.onMenuClick,
        logout = props.logout,
        rest = objectWithoutProperties(props, ['className', 'dense', 'hasDashboard', 'onMenuClick', 'logout']);


    var classes = useStyles$1(props);
    var translate = useTranslate();
    var open = useSelector(function (state) {
        return state.admin.ui.sidebarOpen;
    });
    var pathname = useSelector(function (state) {
        return state.router.location.pathname;
    });
    var resources = useSelector(getResources, shallowEqual);
    var hasList = function hasList(resource) {
        return resource.hasList;
    };

    var _handleToggle = function _handleToggle(parent) {
        /**
         * Handles toggling of parents dropdowns
         * for resource visibility
         */
        setState(function (state) {
            return defineProperty({}, parent, !state[parent]);
        });
    };

    var isXSmall = useMediaQuery(function (theme) {
        return (
            /**
             * This function is not directly used anywhere
             * but is required to fix the following error:
             * 
             * Error: Rendered fewer hooks than expected.
             * This may be caused by an accidental early
             * return statement.
             * 
             * thrown by RA at the time of rendering.
             */
            theme.breakpoints.down('xs')
        );
    });

    var isParent = function isParent(resource) {
        return (
            /**
             * Check if the given resource is a parent
             * i.e. dummy resource for menu parenting
             */
            resource.options && resource.options.hasOwnProperty('isMenuParent') && resource.options.isMenuParent
        );
    };

    var isOrphan = function isOrphan(resource) {
        return (
            /**
             * Check if the given resource is an orphan
             * i.e. has no parents defined. Needed as
             * these resources are supposed to be rendered
             * as is
             *  
             */
            resource.options && !resource.options.hasOwnProperty('menuParent') && !resource.options.hasOwnProperty('isMenuParent')
        );
    };

    var isChildOfParent = function isChildOfParent(resource, parentResource) {
        return (
            /**
             * Returns true if the given resource is the
             * mapped child of the parentResource
             */
            resource.options && resource.options.hasOwnProperty('menuParent') && resource.options.menuParent == parentResource.name
        );
    };

    var MenuItem$$1 = function MenuItem$$1(resource) {
        return (
            /**
             * Created and returns the MenuItemLink object component
             * for a given resource.
             */
            React.createElement(MenuItemLink, {
                key: resource.name,
                to: '/' + resource.name,
                primaryText: translate(resource.options.label),
                leftIcon: resource.icon ? React.createElement(resource.icon, null) : React.createElement(DefaultIcon, null),
                onClick: onMenuClick,
                dense: dense,
                sidebarIsOpen: open
            })
        );
    };

    /**
     * Mapping a "parent" entry and then all its children to the "tree" layout
     */
    var mapParentStack = function mapParentStack(parentResource) {
        return React.createElement(
            CustomMenuItem,
            {
                key: parentResource.name,
                handleToggle: function handleToggle() {
                    return _handleToggle(parentResource.name);
                },
                isOpen: state[parentResource.name] || parentActiveResName === parentResource.name,
                sidebarIsOpen: open,
                name: parentResource.options.label,
                icon: parentResource.icon ? React.createElement(parentResource.icon, null) : React.createElement(LabelIcon, null),
                dense: dense
            },

            // eslint-disable-next-line
            resources.filter(function (resource) {
                return isChildOfParent(resource, parentResource) && hasList(resource);
            }).map(function (childResource) {
                return MenuItem$$1(childResource);
            })
        );
    };

    /**
     * Mapping independent (without a parent) entries
     */
    var mapIndependent = function mapIndependent(independentResource) {
        return hasList(independentResource) && MenuItem$$1(independentResource);
    };

    /**
     * Initialising the initialExpansionState and
     * active parent resource name at the time of
     * initial menu rendering.
     */
    var initialExpansionState = {};
    var parentActiveResName = null;

    /**
     * Initialise all parents to inactive first.
     * Also find the active resource name.
     */
    resources.forEach(function (resource) {
        if (isParent(resource)) {
            initialExpansionState[resource.name] = false;
        } else if (pathname.startsWith('/' + resource.name) && resource.options.hasOwnProperty('menuParent')) {
            parentActiveResName = resource.options.menuParent;
        }
    });

    var _useState = useState(initialExpansionState),
        _useState2 = slicedToArray(_useState, 2),
        state = _useState2[0],
        setState = _useState2[1];

    /**
     * The final array which will hold the array
     * of resources to be rendered
     */


    var resRenderGroup = [];

    /**
     * Looping over all resources and pushing the menu tree
     * for rendering in the order we find them declared in
     */
    resources.forEach(function (r) {
        if (isParent(r)) resRenderGroup.push(mapParentStack(r));
        if (isOrphan(r)) resRenderGroup.push(mapIndependent(r));
    });

    return React.createElement(
        'div',
        null,
        React.createElement(
            'div',
            _extends({
                className: classnames(classes.main, className)
            }, rest),
            hasDashboard && React.createElement(DashboardMenuItem, {
                onClick: onMenuClick,
                dense: dense,
                sidebarIsOpen: open
            }),
            resRenderGroup
        )
    );
};

Menu.propTypes = {
    classes: PropTypes.object,
    className: PropTypes.string,
    dense: PropTypes.bool,
    hasDashboard: PropTypes.bool,
    logout: PropTypes.element,
    onMenuClick: PropTypes.func
};

Menu.defaultProps = {
    onMenuClick: function onMenuClick() {
        return null;
    }
};

export default Menu;
